import { Link } from "react-router-dom";
import strings from "../../data/strings";
import logover from "../../images/Logo-05.svg";
import logohor from "../../images/Logo-07.svg";
import "./Footer.css";
import { useEffect, useState } from "react";
import { IPlan } from "../../types/subscription";
import { getAllSubscriptions } from "../../services/subscription.service";

export const Footer = () => {
  const [subscriptions, setSubscriptions] = useState<IPlan[]>([]);

  useEffect(() => {
    getAllSubscriptions()
      .then((res) => {
        setSubscriptions(res);
      })
      .catch((error) => {
        console.error(subscriptions);
      });
  }, []);

  function goToTop() {
    window.scrollTo(0, 0);
  }
  return (
    <>
      <div id="footer">
        <div className="footer-container">
          <div className="footer-box">
            <picture>
              <source media="(max-width: 870px)" srcSet={logohor} />
              {/* <source media="(min-width: 871px)" srcSet={logover} /> */}
              <img src={logover} alt="Ellie Care" />
            </picture>
          </div>
        </div>
        <div className="footer-container">
          <div className="footer-container-inner">
            <div className="footer-box-left">
              <div>
                <a href={"/"} style={{ fontWeight: "900" }} onClick={goToTop}>
                  Ellie Care
                </a>
              </div>
              <div>
                <Link to={"/QueHacemos"}>· Qué hacemos</Link>
              </div>
              <div>
                <Link to={"/NuestraPlataforma"}>· Nuestra Plataforma</Link>
              </div>
              <br />
              <div>
                <Link to={"/NuestrosPlanes"} style={{ fontWeight: "900" }}>
                  Planes
                </Link>
              </div>
              {subscriptions &&
                subscriptions.map((plan) => (
                  <div>
                    <Link to={`/subscription/${plan.id}`}>· {plan.name}</Link>
                  </div>
                ))}
            </div>

            <div className="footer-box-right">
              <div>
                <a
                  href="https://backoffice.elliecenter.com"
                  style={{ fontWeight: "900", textDecoration: "none" }}
                >
                  Iniciar Sesión
                </a>
              </div>
              <br />
              <div>
                <Link
                  to={"/"}
                  style={{ fontWeight: "900", textDecoration: "none" }}
                >
                  Contacto
                </Link>
              </div>
              <br />
              <div>
                <a
                  href={strings.priv_policy}
                  style={{ fontWeight: "900", textDecoration: "none" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Políticas de Privacidad
                </a>
              </div>
              <br />
              <div>
                <a
                  href={strings.terms_and_cond}
                  style={{ fontWeight: "900", textDecoration: "none" }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Términos y Condiciones
                </a>
              </div>
            </div>
          </div>

          <div className="footer-container-inner">
            <div className="footer-box-left">
              <div
                style={{
                  color: "#aabcd7",
                  fontWeight: "900",
                  textDecoration: "none",
                }}
              >
                Trabajá con nosotros
              </div>
              <div>
                <a
                  href="mailto:hr@ellie.care"
                  style={{ textDecoration: "none" }}
                >
                  hr@ellie.care
                </a>
              </div>
              <br />
              <div style={{ color: "#aabcd7", fontWeight: "900" }}>Email</div>
              <div>
                <a
                  href="mailto:ventas@ellie.care"
                  style={{ textDecoration: "none" }}
                >
                  ventas@ellie.care
                </a>
              </div>
              <br />
              <div style={{ color: "#aabcd7", fontWeight: "900" }}>
                WhatsApp
              </div>
              <div>
                <a
                  href={
                    "https://wa.me/" +
                    strings.whatsapp_number +
                    "?text=" +
                    strings.whatsapp_message
                  }
                  style={{ textDecoration: "none" }}
                >
                  +54 9 11 6996 3554
                </a>
              </div>
            </div>

            <div className="footer-box-right">
              <div style={{ color: "#aabcd7", fontWeight: "900" }}>
                Seguínos!
              </div>
              <br />
              <div>
                <a href={strings.linkedin} target="_blank" rel="noreferrer">
                  LinkedIn
                </a>
              </div>
              <br />
              <div>
                <a href={strings.instagram} target="_blank" rel="noreferrer">
                  Instagram
                </a>
              </div>
              <br />
              <div>
                <a href={strings.facebook} target="_blank" rel="noreferrer">
                  Facebook
                </a>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
      <div className="footer-container-copyright">
        Copyright © 2022-{new Date().getFullYear()} Ellie Care All rights
        reserved.
      </div>
    </>
  );
};

export default Footer;
